import * as React from 'react'
import { StepperCollege } from '../stepper-college/stepper-college'
import { FormLoginCollege } from '../form-login-college/form-login-college'
import { FormHomeStep } from '../form-home-step/form-home-step'
import { FormRegisterKeys } from '../form-register-keys/form-register-keys'
import { FormRegisterCollege } from '../form-register-college/form-register-college'
import { ModalUpdateData } from '../modal-update-data/modal-update-data'
import { ModalInvalidAge } from '../../modals/modal-invalid-age/modal-invalid-age'
import { ModalInvalidCountry } from '../../modals/modal-invalid-country/modal-invalid-country'
import { Context } from '../../../context/app-context'
import { concourseId, rangeAge } from '../../../constants/activity-constants'
import CollegeService from '../../../services/college-service'
import DataPolicyService from '../../../shared/services/datapolicy-service'
import { localStorage } from '../../../shared-campaign/utils/storage-helper'
import CompetitionService from '../../../shared-campaign/services/competition'
import { CalculateAge } from '../../../shared-campaign/utils/userAgeValidations'
import './form-college.scss'
import AuthService from '../../../shared/services/auth-service'

export const FormCollege = () => {
  const { userInfo, hasParticipation, dispatch } = React.useContext(Context)
  const idSection = hasParticipation ? 'registrar-claves' : 'registrate'
  const [formStep, setFormStep] = React.useState(1)

  const handleNextStep = () => setFormStep(step => step + 1)

  const onCloseUpdateData = () => {
    setFormStep(2)
  }

  const onSuccessUpdateData = () => {
    setFormStep(2)
  }

  const defaultProps = {
    handleNextStep,
    setFormStep,
  }

  const FORM_STEPS = {
    1: <FormLoginCollege {...defaultProps} />,
    2: <FormHomeStep {...defaultProps} />,
    3: <FormRegisterKeys {...defaultProps} />,
    4: <FormRegisterCollege {...defaultProps} />,
    'no-valid-age': <ModalInvalidAge {...defaultProps} />,
    'no-valid-country': <ModalInvalidCountry {...defaultProps} />,
    'modal-update-data': <ModalUpdateData success={onSuccessUpdateData} />,
  }

  const registerParticipation = React.useCallback(() => {
    let payload = {
      competitionId: concourseId,
    }

    CollegeService.saveParticipation(payload).then(response => {
      if (response.status === 200) {
        dispatch({
          type: 'set',
          payload: {
            hasParticipation: true,
          },
        })
      }
    })
  }, [dispatch])

  const getUserIsParticipating = async () => {
    let response = await CompetitionService.getParticipation({
      concourseId: concourseId,
    })

    return response?.status === 200
  }

  const validateUserParticipation = React.useCallback(() => {
    getUserIsParticipating().then(isParticipating => {
      if (isParticipating) {
        dispatch({ type: 'set', payload: { hasParticipation: true } })
      } else {
        registerParticipation()
      }
    })
  }, [dispatch, registerParticipation])

  const getUserParticipation = React.useCallback(() => {
    CollegeService.getUserParticipation({ concourseId }).then(response => {
      if (response.status === 200) {
        dispatch({
          type: 'set',
          payload: { userParticipation: response.data },
        })
      }
    })
  }, [dispatch])

  const validateHabeasData = () => {
    let tokenId = localStorage.getItem('TOKEN_INFO')?.idToken
    return DataPolicyService.getUserParticipationCampaign(concourseId, {
      headers: {
        Authorization: tokenId,
      },
    }).then(response => {
      return (
        response?.data?.dataPolicy && response?.data?.participationConcourse
      )
    })
  }

  const validateCountryUser = () => {
    let tokenId = localStorage.getItem('TOKEN_INFO')?.idToken
    var config = {
      headers: {
        Authorization: tokenId,
      }
    }
    return AuthService.sessionInfo(config).then(response => {
      return (
        response?.data?.countryName
      )
    })
  }


  //validate if user have correct age
  React.useEffect(() => {
    if (userInfo) {
      const userAge = CalculateAge(userInfo.birthdate || '')
      const isValidAge = userAge >= rangeAge.minAge && userAge <= rangeAge.maxAge
      const countryLocale = process.env.COUNTRY_NAME.toUpperCase()

      // method if country is valid
      const onValidCounntry = () => {
        if (!isValidAge) {
          setFormStep('no-valid-age')
        } else {
          if (!hasParticipation) {
            //validate if user has participation and register participation
            validateUserParticipation()
          } else {
            //getUserParticipation when user is logged and has participation
            getUserParticipation()
          }
  
          validateHabeasData()
            .then(hasHabeasData => {
              if (hasHabeasData) {
                setFormStep(2)
              } else {
                setFormStep('modal-update-data')
              }
            })
            .catch(() => {
              setFormStep(2)
            })
        }
      }
      //resolve promise validateCountryUser
      validateCountryUser().then((countryUser)=>{
        if(countryUser === countryLocale){
          onValidCounntry()
        }else{
          setFormStep('no-valid-country')
        }
      })

    }
  }, [
    userInfo,
    hasParticipation,
    validateUserParticipation,
    getUserParticipation,
  ])

  return (
    <section className="f-form-college" id={idSection}>
      {formStep !== 'no-valid-age' && (
        <>
          {formStep === 1 && (
            <h2 className="f-form-college__title">
              Recuerda que para participar en <b>Cole Challenge</b>, debes estar
              registrada en <b>NosotrasOnline</b>.
            </h2>
          )}

          <div className="f-form-college__stepper">
            <StepperCollege activeStep={formStep} numberOfSteps={3} />
          </div>
        </>
      )}

      {FORM_STEPS[formStep]}
    </section>
  )
}
